import { Routes, Route, Navigate } from 'react-router-dom';
import { AppLayout } from './shared/layout/app-layout';
import { InstitutionGuard } from './shared/guards/InstitutionGuard';
import { DashboardPage } from './pages/dashboard-page';
import { FEATURE_FLAGS } from './lib/feature-flags';

export function AppRoutes() {
  return (
    <Routes>
      <Route
        path="/:institution"
        element={
          <InstitutionGuard>
            <AppLayout />
          </InstitutionGuard>
        }
      >
        <Route index element={<Navigate to="edition" replace />} />
        <Route path="edition" element={<DashboardPage />} />
        <Route path="edition/:edition" element={<DashboardPage />} />
        <Route path="edition/:edition/geral" element={<DashboardPage />} />
        <Route path="edition/:edition/aluno" element={<DashboardPage />} />
        <Route
          path="edition/:edition/aluno/:email"
          element={<DashboardPage />}
        />
        <Route path="edition/:edition/questoes" element={<DashboardPage />} />
        <Route
          path="global"
          element={
            FEATURE_FLAGS.globalDashboard ? (
              <DashboardPage />
            ) : (
              <Navigate to="edition" replace />
            )
          }
        />
        <Route
          path="global/geral"
          element={
            FEATURE_FLAGS.globalDashboard ? (
              <DashboardPage />
            ) : (
              <Navigate to="edition" replace />
            )
          }
        />
        <Route
          path="global/aluno"
          element={
            FEATURE_FLAGS.globalDashboard ? (
              <DashboardPage />
            ) : (
              <Navigate to="edition" replace />
            )
          }
        />
        <Route
          path="global/aluno/:email"
          element={
            FEATURE_FLAGS.globalDashboard ? (
              <DashboardPage />
            ) : (
              <Navigate to="edition" replace />
            )
          }
        />
      </Route>
      <Route path="*" element={<Navigate to="/FAG" replace />} />
    </Routes>
  );
}
